import { getGlobalConf } from '@/utils/grocer';
const conf = getGlobalConf();

export const API_FILE_DOWNLOAD = `${conf.baseURL}/download/file?processInstanceId=&filePath=`;
export const API_FILE_UPLOAD = `${conf.baseURL}/upload/file/sample`;
export const API_IMG_UPLOAD = `${conf.baseURL}/upload/image/sample`;
export const API_IMG_DOWNLOAD = `${conf.baseURL}/download/image?filePath=`;
export const API_IMG_IMAGECODE = `${conf.baseURL}/cs/user/createImageCode?d=`;

export const API_USER_LOGIN_PRE = '/cs/user/loginPre';
export const API_USER_LOGIN = '/login';
export const API_USER_LOGINOUT = '/loginOut';
export const API_USER_CURRENT_LOGIN = '/cs/user/getLoginUser';
export const API_USER_GET_MY_BASEINFO = '/cs/user/getMyBaseInfo';
// 生成pdf并获取pdf地址
export const API_PDF_CREATE_AND_PREVIEW = '/preview/getPdfPath';

// 工作台
export const API_WORKBENCH_PROCESS_TASK_CNT = '/workbench/getProcessTaskCnt';
export const API_WORKBENCH_APPROVAL_CNT = '/approval/instance/getApprovalCnt';
export const API_WORKBENCH_PROCESS_TASK_CNT_NEW = '/process/task/getProcessTaskCntNew';

// 自定义表单
export const API_FORM_TEMPLATE_LIST = '/component/customForm/getFormList';
export const API_FORM_TEMPLATE_DETAIL = '/component/customForm/getFormConfig';
export const API_FORM_CROSS_TEMPLATE_LIST = '/component/customForm/getCrossFormConfigs';
export const API_FORM_TEMPLATE_SAVE = '/component/customForm/saveCustomForm';
export const API_FORM_GET_COPY_TREE_CONFIG = '/component/customForm/getCopyTreeConfig';
export const API_FORM_TEMPLATE_GETFORMDATALINKCONFIG = '/component/customForm/getFormDataLinkConfig';
export const API_FORM_TEMPLATE_GET_CUSTOMFORMRULECONFIG = '/component/customForm/getCustomFormRuleConfig';
export const API_FORM_TEMPLATE_GET_FORM_DATA_AUTH_LIST = '/component/customForm/getFormDataUpdConfigBOList';
export const API_FORM_TEMPLATE_DELETE = '/component/customForm/deleteCustomForm';
export const API_FORM_TEMPLATE_FORMCONFIGS = '/component/customForm/getFormConfigs';
export const API_FORM_TEMPLATE_BI_FORMCONFIGS = '/component/customForm/getBIFormConfigs';
export const API_FORM_TEMPLATE_BI_DATA = '/component/customForm/getFormDashBoardData';
export const API_FORM_FIELD_STATISTICS = '/component/customForm/getFormFieldstatistics';
export const API_FORM_FIELD_STATISTICSGROUP = '/component/customForm/getFormFieldstatisticsGroup';
export const API_FORM_GETPROGRESSBARLIST = '/component/customForm/getProgressBarList';
export const API_FORM_GETDATAPROGRESSBARLIST = '/component/customForm/getDataProgressBarList';
export const API_FORM_TEMPLATE_WAREHOUSING = '/component/customForm/getFormWarehousing';
export const API_FORM_TEMPLATE_BI_CONFIG = '/component/customForm/getFormDashBoardConfig';
export const API_FORM_TEMPLATE_AGGREGATE_TABLE_CONFIG = '/component/customForm/getFormAggregateTableConfig';

export const API_FORM_FORMFIELDS = '/component/customForm/getFormFieldListByIds';
export const API_FORM_UPDATEUSERFORMVIEWFIELD = '/application/model/updateuserformviewfield';
export const API_FORM_SELECT_OPTION_SAVE = '/component/customForm/saveConfigOption';
export const API_FORM_SELECT_OPTION_LIST_SAVE = '/component/customForm/saveConfigOptionList';
export const API_FORM_CALCULATION_SAVE = '/component/customForm/saveCalculation';
export const API_FORM_SUBFORM_SUMMARY_SAVE = '/component/customForm/saveSubFormSummary';
export const API_FORM_UP_MONEY_FIELD_LIST = '/component/customForm/getUpMoneyFieldList';
export const API_FORM_CASCADE_DEPT_ROOT_ID = '/component/customForm/getCascadeDeptRootId';

export const API_FORM_TEMPLATE_DETAIL_HISTORY = '/component/customForm/getFormConfigHistory';
export const API_FORM_TEMPLATE_REVERT_CUSTOMFORM = '/component/customForm/revertCustomForm';

export const API_FORM_TEMPLATE_LIST_BY_MAIN_FORMID = '/component/customForm/getFormListByMainFormId';
export const API_GET_FORMULA_SEARCHLIST = '/component/customForm/getFormulaSearchList';
export const API_FORM_MODEL_LIST_BY_MAIN_FORMID = '/component/customForm/getModelListByMainFormId';
export const API_FORM_MODEL_LIST_BY_REF_FORMIDS = '/component/customForm/getModelListByRefFormIds';
export const API_FORM_FIELD_LIST_BY_FIELDID = '/component/customForm/getFormFieldListByFieldId';
export const API_FORM_FIELD_LIST_BY_MAIN_FORM_FIELDID = '/component/customForm/getFieldListByMainFormFiedId';
export const API_FORM_FIELD_LIST_MAP_BY_MAIN_FORM_FIELDIDS = '/component/customForm/getFieldListMapByMainFormFiedIds';
export const API_FORMS_LIST_BY_FIELD_TYPE = '/component/customForm/getCustomFormsByFiedIdType';
export const API_MODEL_FORM_LEFT_TREE = '/component/customForm/getFormLeftTree';// 表单左树右表接口
export const API_IMPORT_COPY_MODEL = `${conf.baseURL}/component/customForm/importCopyModel`;

// 流程数据表单同步相关接口
export const API_PROCESS_CUSTOM_FORMDATA_MAPING_LIST = '/processCustomForm/getCustomFormDataMapingListByFormId';
export const API_PROCESS_CUSTOM_FORMDATA_MAPING_SAVE = '/processCustomForm/saveCustomFormDataMapings';
export const API_PROCESS_CUSTOM_FORMDATA_SYNC = '/processCustomForm/syncProcessFormData';

// 用户管理
export const API_USER_CHECKUSERIFEXIST = '/cs/user/checkUserIfexist/:input';
export const API_USER_CHECKUSERIFEXIST_FOR_MY_BASEINFO_EDIT = '/cs/user/checkUserIfexistForEdit/:input';
export const API_USER_LIST = '/cs/user/getUserList';
export const API_USER_DETAIL = '/cs/user/getUser/:userId';
export const API_USER_SAVE = '/cs/user/saveUser';
export const API_USER_DELETE = '/cs/user/deleteUser/:userId';
export const API_USER_CHANGE_STATE = '/cs/user/updUserState';
export const API_USER_UPD_PWD = '/cs/user/updUserPwd';
export const API_GET_USER_WORK_PLANT_ENTRY = '/cs/user/getUseWorkPlantEntry';
export const API_ADD_USER_FIRST_PAGE_CONFIG = '/cs/user/addUserFirstPageConfig';
export const API_GET_USER_FIRST_PAGE_CONFIG = '/cs/user/getUserFirstPageConfig';
export const API_UPDATE_WORK_PLANT_ENTRY = '/cs/user/updateWorkPlantEntry';
export const API_DRAG_WORK_PLANT_ENTRY = '/cs/user/dragWorkPlantEntry';
export const API_NEW_TENANT_ADD_BY_CS = '/cs/user/addNewTenantByCs';
// 更新用户当前使用版本，1：旧版，2:2.0版
export const API_USER_SWITCHLAYOUTFLG = '/cs/user/updSwitchLayoutFlg';
// 首页模式 0工作台  1应用系统  2仪表盘
export const API_USER_PORTALMODE = '/cs/user/updPortalMode';

// 员工管理
export const API_EMPLOYEE_LIST = '/system/employee/getEmployeeList';
export const API_EMPLOYEE_DETAIL = '/system/employee/getEmployee/:employeeId';
export const API_EMPLOYEE_SAVE = '/system/employee/saveEmployee';
export const API_SAVE_SON_TEMPDATA = '/system/employee/saveSonTempData';
export const API_GET_SON_TEMPDATA = '/system/employee/getSonTempData';
export const API_EMPLOYEE_DELETE = '/system/employee/deleteEmployee/:employeeId';
export const API_EMPLOYEE_LIST_EXPORT_TO_EXCEL = `${conf.baseURL}/excel/exportEmployeeListToExcel?keyword=:keyword&totalPageNum=:totalPageNum`;
export const API_EMPLOYEE_QUIT_LIST = '/cs/user/getUserQuitList';
export const API_EMPLOYEE_QUIT = '/system/employee/quitEmployee';
export const API_EMPLOYEE_REF_UPD = '/system/employee/updEmployeeRefData';
export const API_EMPLOYEE_HANDOVER = '/system/employee/handoverEmployee';

// 企业管理
export const API_COMPANY_LIST = '/system/company/getCompanyList';
export const API_COMPANY_DETAIL = '/system/company/getCompany/:companyId';
export const API_MY_COMPANY_DETAIL = '/system/company/getMyCompany';
export const API_COMPANY_SAVE = '/system/company/saveCompany';
export const API_COMPANY_DELETE = '/system/company/deleteCompany/:companyId';
export const API_COMPANY_UPLOAD = '/system/company/saveCompanyLicence';
export const API_COMPANY_CHANGE_AUDITSTATE = '/system/company/authentication';

// 部门管理
export const API_DEPARTMENT_LIST = '/system/department/getDepartmentList';
export const API_DEPARTMENT_DETAIL = '/system/department/getDepartment/:departmentId';
export const API_DEPARTMENT_SAVE = '/system/department/saveDepartment';
export const API_DEPARTMENT_DELETE = '/system/department/deleteDepartment/:departmentId';
export const API_DEPARTMENT_TREE_LIST = '/system/department/getDepartmentTreeList';
export const API_DEPARTMENT_TREE_DRAG = '/system/department/dragDepartmentTree';

// 岗位管理
export const API_POSITION_LIST = '/system/position/getPositionList';
export const API_POSITION_TREE_LIST = '/system/position/getPositionTreeList';
export const API_POSITION_TREE_DRAG = '/system/position/dragPositionTree';
export const API_POSITION_DETAIL = '/system/position/getPosition/:positionId';
export const API_POSITION_SAVE = '/system/position/savePosition';
export const API_POSITION_DELETE = '/system/position/deletePosition/:positionId';

// 流程管理
export const API_PROCESS_DEFINITION_UNPUBLIC_CHECK = '/process/processSetting/checkUnPublicedProcessDefinition';
export const API_WORKFLOW_MY_PROCESSES = '/app/rest/models';
// export const API_PROCESS_LIST = '/app/rest/models';
export const API_PROCESS_UPDATE_MODEL = '/process/processSetting/updModel';
export const API_PROCESS_LIST = '/process/processSetting/getAllProcessDefinitionLists';
export const API_PROCESS_SETTING_STATUS = '/process/processSetting/enableProcessDefinition';
export const API_PROCESS_UPLOAD_TEMPLATE = `${conf.baseURL}/process/processSetting/uploadFile`;
export const API_PROCESS_SAVE = '/app/rest/models';
export const API_PROCESS_CLONE = '/app/rest/models/:processDefinitionId/clone';
export const API_PROCESS_DELETE = '/app/rest/models/:processDefinitionId';
export const API_PROCESS_SERVICE_LIST = '/process/processService/getProcessServiceList';
export const API_PROCESS_SERVICE_DETAIL = '/process/processService/getProcessService/:processId';
export const API_PROCESS_SERVICE_TEMPLATE = '/process/processService/getProcessServiceTemplate/:processServiceId/:deploymentId';
export const API_PROCESS_SERVICE_SAVE = '/process/processService/saveProcessService';
export const API_PROCESS_SERVICE_DELETE = '/process/processService/delProcessService';
export const API_PROCESS_SERVICE_PUBLISH = '/process/processService/:processServiceId/:deploymentId/publish';
export const API_PROCESS_TEMPLATE_PUBLISH = '/process/processService/publishTemplate';
export const API_PROCESS_TEMPLATE_SAVE = '/process/processService/saveProcessTemplate';
export const API_PROCESS_SERVICE_ENABLE_LIST = '/process/processService/getEnableProcessDefinitionList';
export const API_PROCESS_SERVICE_ELEMENT_CONFIG = '/process/processService/getProcessServiceConfig/:processServiceId/:deploymentId/:taskId';
export const API_PROCESS_SERVICE_ELEMENT_INSTANCE_CONFIG = '/process/processService/getProcessServiceInstanceConfig/:processServiceId/:deploymentId/:processInstanceId/:taskId';
export const API_PROCESS_SERVICE_ELEMENT_SAVE = '/process/processService/saveProcessServiceConfig';
export const API_PROCESS_SERVICE_SEQUENCE_FLOW_CONFIG = '/process/processService/getSequenceFlowConfig/:sequenceFlowId/:deploymentId';
export const API_PROCESS_SERVICE_SEQUENCE_FLOW_CONDITIONS = '/process/processService/getServiceSequenceFlowConditions/:processServiceId/:deploymentId';
export const API_PROCESS_SERVICE_SEQUENCE_FLOW_SAVE = '/process/processService/saveSequenceFlowConfig';
export const API_PROCESS_SERVICE_CALL_ACTIVITY_CONFIG = '/process/processService/getProcessCallActivityConfig/:callActivityId/:deploymentId';
export const API_PROCESS_SERVICE_CALL_ACTIVITY_SAVE = '/process/processService/saveCallActivityConfig';
export const API_PROCESS_SERVICE_FORMS = '/process/processService/getProcessServiceForms';
export const API_PROCESS_SERVICE_FORMS_AUTH = '/process/processService/getProcessServiceFormsAuth';
export const API_PROCESS_SERVICE_SAVE_FORMS_AUTH = '/process/processService/saveProcessServiceFormAuth';
export const API_PROCESS_SERVICE_SAVE_BATCH_DATA_AUTH = '/process/processService/saveBatchProcessServiceDataAuth';
export const API_PROCESS_SERVICE_DELETE_BATCH_DATA_AUTH = '/process/processService/deleteBatchProcessServiceDataAuth';
export const API_USER_PROCESS_DATA_AUTH_LIST = '/process/processService/getUserProcessServiceDataAuthList';
export const API_PROCESS_SERVICE_TASK_FORMS = '/process/processService/getProcessServiceTaskForms';
export const API_PROCESS_SERVICE_TASKS = '/process/processService/getServiceTasks/:processServiceId/:deploymentId';

export const API_PROCESS_PUBLISHED_LIST = '/process/processService/getPublishedProcessLists';
export const API_PROCESS_PUBLISHED_START = '/process/processInstance/startProcess';

export const API_PROCESS_SERVICE_USER_RELATION_SAVE = '/process/processService/saveProcessServiceUserRelation';
export const API_ALL_PROCESS_SERVICE_USER_RELATION_SAVE = '/process/processService/saveAllProcessServiceUserRelation';
export const API_PROCESS_SERVICE_USER_RELATION_SAVE_FOR_CREATEBY = '/process/processService/saveProcessServiceUserRelationForCreateBy';
export const API_ALL_PROCESS_SERVICE_USER_RELATION_CANCEL = '/process/processService/cancelAllProcessServiceUserRelation';

export const API_PROCESS_RELATE_TREE_LIST = '/process/processInstance/getProcessRelateTreeList/:processInstanceId';
export const API_PROJET_MAIN_LINE_TREE_LIST = '/process/processInstance/getProjectMainLineTreeList';
export const API_PROCESS_COMPLATE_TREE = '/process/processInstance/getComplateProcessTree/:processInstanceId';
export const API_PROCESS_RELATE_TREE_LIST_EXPORT_TO_EXCEL = `${conf.baseURL}/excel/exportProcessRelateTreeList/:processInstanceId`;
export const API_PROCESS_RELATE_TREE_LIST_EXPORT_TO_ALL_EXCEL = `${conf.baseURL}/excel/exportProcessRelateTreeList/exportAllProcessList`;
export const API_PROCESS_RELATE_TREE_LIST_EXPORT_TO_ALL_EXCEL_PARAM = `${conf.baseURL}/excel/exportProcessRelateTreeList/exportAllProcessListByParam/:processServiceId/:state/:serviceName/:currentBusinessId/:assigneeUserId/:startedByUserId/:hasSubProcess/:beginDate/:endDate`;
export const API_ALL_TASK_LIST_EXPORT_TO_ALL_EXCEL_PARAM = `${conf.baseURL}/excel/exportTaskAllDataList/:taskName/:taskAssignee/:state/:processInstanceName/:processServiceId/:startedByUserId/:hasTaskSubProcess/:hasApproval/:assignment/:relationProcessInstanceName/:beginDate/:endDate`;
export const API_ALL_APPROVE_LIST_EXPORT_TO_ALL_EXCEL_PARAM = `${conf.baseURL}/excel/exportApproveAllDataList/:approvalType/:approvalName/:busiProcessInstanceName/:taskName/:approvalStatus/:approvalPeopleType/:selectedUserIds/:beginDate/:endDate`;
export const API_PROCESS_PROCESS_COPY_USER_LIST = '/process/processInstance/getProcessInstanceCopyUsers';
export const API_PROCESS_PROCESS_COPY_USER_UPD = '/process/processInstance/saveProcessInstanceCopyUsers';
// 审批流
export const API_APPROVAL_TEMPLATE_LIST = '/approval/template/getApprovalTemplateList';
export const API_APPROVAL_TEMPLATE_SAVE = '/approval/template/saveApprovalTemplate';
export const API_APPROVAL_TEMPLATE_DELETE = '/approval/template/deleteApprovalTemplate/:id';
export const API_APPROVAL_TEMPLATE_PUBLISH = '/approval/template/publish/:templateId/:templateState';

export const API_APPROVAL_INSTANCE_SAVE = '/approval/instance/saveApprovalInstance';
export const API_APPROVAL_INSTANCE_LIST = '/approval/instance/getApprovalInstanceList';
export const API_CARBONCOPY_INSTANCE_LIST = '/approval/instance/getCarbonCopyInstanceList';
export const API_ALL_APROVELIST = '/approval/instance/getAllAproveList';

export const API_APPROVAL_INSTANCE_PASS = '/approval/instance/addPassApproval';
export const API_APPROVAL_INSTANCE_REJECT = '/approval/instance/addRejectApproval';
export const API_APPROVAL_INSTANCE_DELETE = '/approval/instance/deleteApprovalInstance/:id';
export const API_APPROVAL_UPDATE_USER = '/approval/instance/updateApprovalUser';
export const API_APPROVAL_INSTANCE_WITHDRAW = '/approval/instance/delWithdrawApproval';
export const API_APPROVAL_RECORD_LIST = '/approval/instance/getApprovalRecordList';
export const API_APPROVAL_INSTANCE_USER_LIST = '/approval/instance/getApprovalInstanceUserListById';
export const API_APPROVAL_MODELFORM_INSTNCE_DUR_LIST = '/approval/instance/getModelFormInstanceApprovalDurList';
export const API_APPROVAL_INSTNCE_APPROVAL_RECORD_LIST_BY_MODELINSTANCEID = '/approval/instance/getApprovalRecordListByModelInstanceId';

export const API_APPROVAL_INSTANCE = '/approval/instance/getApprovalInstance/:id';
export const API_APPROVAL_IS_CAN_APPROVAL = '/approval/instance/getIsCanApproval';

export const API_APPROVAL_INSTANCES_GET_FILES = '/approval/instance/getFiles';
export const API_APPROVAL_INSTANCE_ID_LAST_BY_FORM_ID = '/approval/instance/getLastTaskApprovalInstanceIdByFromId';
// 根据表单填写内容，选择审批模板
export const API_APPROVAL_TEMPLATE_GET_BY_FORMDATA = '/approval/instance/getApprovalTemplateByFormData';
export const API_APPROVAL_TEMPLATE_GET_BY_TASK_FORMDATA = '/approval/instance/getApprovalTemplateByTaskFormData';
// 推送审批流模板到商店
export const API_APPROVAL_TEMPLATE_PUSH_TO_CS = '/approval/template/copyApprovalTemplateToCs';
// 我的任务
export const API_PROCESS_TASKINSTANCE_EXECUTE_RECORD_LIST = '/process/task/getTaskInstanceExecuteRecordBOList';
export const API_PROCESS_TASK_DOING_LIST = '/process/task/getDoingTaskList';
export const API_PROCESS_TASK_LIST = '/process/task/getProcessTaskList';
export const API_PROCESS_TASK_ADDTASKUSERREMARK = '/process/task/addTaskUserRemark';
export const API_PROCESS_TASK_UPDATETASKUSERREMARK = '/process/task/updateTaskUserRemark';
export const API_PROCESS_TASK_DETAIL = '/process/task/getProcessTask/:taskId';
export const API_PROCESS_TASK_CLAIM = '/process/task/claim/:taskId';
export const API_PROCESS_TASK_TEMPORARY_SAVE = '/process/task/temporarySave/:taskId';
export const API_PROCESS_TASK_COMPLETE = '/process/task/complete/:taskId';
export const API_PROCESS_TASK_REVOKETASK = '/process/task/revokeTask/:taskId';
export const API_PROCESS_TASK_DELETE = '/process/task/deleteTask/:processInstanceId/:taskId';
export const API_PROCESS_TASK_HIDDEN = '/process/task/hiddenTask';
export const API_PROCESS_TASK_COMMENT_LIST = '/process/task/getComments';
export const API_PROCESS_TASK_COMMENT_SAVE = '/process/task/saveComment';
export const API_PROCESS_TASK_COMMENT_DELETE = '/process/task/delComment/:commentId';
export const API_PROCESS_TASK_UPLOAD_FILE = '/process/task/uploadFile';
export const API_PROCESS_TASK_GET_FILES = '/process/task/getFiles';
export const API_PROCESS_TASK_DELETE_FILE = '/process/task/delFile';
export const API_PROCESS_TASK_INVOLVEUSER = '/process/task/involveUser';
export const API_PROCESS_TASK_TRANSFERASSIGNEE = '/process/task/transferAssignee';
export const API_PROCESS_TASK_INTERVENE_SAVE = '/process/task/interveneProcessTaskConfig';
export const API_PROCESS_TASK_BATCH_CHANGE_TASK_ASSIGNEE_USER = '/process/task/batchChangeTaskAssigneeUser';
export const API_PROCESS_TASK_SAVE_TAGS = '/process/task/saveTags';
export const API_PROCESS_TASK_SAVE_ARCHIVE_TREE_FILE_RELATION = '/process/task/saveArchiveTreeFileRelation';
export const API_PROCESS_TASK_NEXT_TASK_NODE_LIST = '/process/task/getNextTaskNodeList';
export const API_PROCESS_TASK_FILE_SHARE_ADD = '/process/task/addProcessFileShare';
export const API_PROCESS_TASK_FILE_SHARE_DEL = '/process/task/delProcessFileShare/:fileId/:processInstanceId';

export const API_PROCESS_TASK_COMMENT_SENDMSG = '/process/processInstance/sendCommentMsg';
export const API_PROCESS_TASK_APPROVL_TEMPLATE_LIST_BY_TASKID = '/process/task/getApprovalTemplateBOListByTaskId';
export const API_PROCESS_TASK_MUTIL_ADD = '/process/task/addMutilTask';
export const API_PROCESS_TASK_MUTIL_DELETE = '/process/task/deleteMutilTask/:processInstanceId/:taskId';
export const API_PROCESS_TASK_INSTANCE_PKID = '/process/task/getProcessInstanceTaskPkId';
export const API_PROCESS_TASK_TEAMWORK_MODEL_INSTANCEID = '/process/task/getTeamWorkModelInstanceId';
export const API_PROCESS_TASK_IS_TEAMWORK_FIRST_TASK_FORM = '/process/task/isTeamWorkModelFirstTaskForm';
export const API_PROCESS_TASK_DELETE_PROCESS_USER = '/process/task/deleteProcessInstanceUserForced';

// 我的流程
export const API_PROCESS_INSTANCES_CNT = '/process/processInstance/getProcessInstanceCnt';
export const API_PROCESS_INSTANCES_LIST = '/process/processInstance/getProcessInstances';
export const API_PROCESS_ALL_INSTANCES_LIST = '/process/processInstance/getAllProcessInstances';// 查询企业内所有的流程实例
export const API_PROCESS_INSTANCES_DETAIL = '/process/processInstance/getProcessInstance/:instanceId';
export const API_PROCESS_INSTANCES_USERS = '/process/processInstance/getProcessInstancesUsers';
export const API_PROCESS_INSTANCES_CANCEL = '/process/processInstance/cancelProcessInstance/:instanceId';
export const API_PROCESS_INSTANCES_DELETE = '/process/processInstance/deleteProcessInstance/:instanceId';
export const API_PROCESS_INSTANCES_RECORD_LIST = '/process/processInstance/getExecutionRecord';
export const API_PROCESS_INSTANCES_COMMENT_LIST = '/process/processInstance/getComments';
export const API_PROCESS_INSTANCES_COMMENT_SAVE = '/process/processInstance/saveComment';
export const API_PROCESS_INSTANCES_COMMENT_DELETE = '/process/processInstance/delComment/:commentId';
export const API_PROCESS_INSTANCES_MODELFORMS = '/process/processInstance/getProcessModelForms';
export const API_PROCESS_INSTANCES_ALLFORMINSTANCE = '/process/processInstance/getProcessAllFormInstances';
export const API_PROCESS_INSTANCES_FIRST_TASK_CAN_DELETE = '/process/processInstance/isFirstTaskCanDelete';
export const API_PROCESS_INSTANCES_ALL_FORMS = '/process/processInstance/getAllProcessTaskForms';
export const API_PROCESS_INSTANCES_UPLOAD_FILE = '/process/processInstance/uploadFile';
export const API_PROCESS_INSTANCES_GET_FILES = '/process/processInstance/getFiles';
export const API_PROCESS_INSTANCES_DELETE_FILE = '/process/processInstance/delFile';
export const API_PROCESS_INSTANCES_ALLUSERTASK = '/process/processInstance/getAllUserTask/:instanceId/:serviceId/:processDefinitionId/:deploymentId';
export const API_PROCESS_SAVE_INSTANCE = '/process/processInstance/complete/:processInstanceId';
export const API_PROCESS_INSTANCE_TEMPLATE_SAVE = '/process/processInstance/saveProcessInstanceTemplate';
export const API_PROCESS_INSTANCE_TEMPLATE = '/process/processInstance/getProcessInstanceTemplate/:processInstanceId/:processServiceId/:deploymentId';
export const API_PROCESS_INSTANCE_ALL_TASK_TO_EXCEL = `${conf.baseURL}/excel/exportAllUserTaskToExcel/?processInstanceId=:processInstanceId&processServiceId=:processServiceId&processDefinitionId=:processDefinitionId&deploymentId=:deploymentId&processInstanceName=:processInstanceName`;
export const API_PROCESS_TIME_CONFIG_DETAIL_TO_EXCEL = `${conf.baseURL}/excel/exportTimeConfigDetailToExcel/?processInstanceId=:processInstanceId&templateId=:templateId`;
export const API_PROCESS_INSTANCES_FORMS_AUTH = '/process/processInstance/getProcessInstanceFormsAuth';
export const API_PROCESS_INSTANCES_SAVE_FORMS_AUTH = '/process/processInstance/saveProcessInstanceFormAuth';
export const API_PROCESS_INSTANCES_ADJ_LIST = '/process/processAdj/getProcessAdjList';
export const API_PROCESS_UPD_PROCESS_ASSIGNEE_USER = '/process/processInstance/updProcessAssigneeUser';
export const API_PROCESS_INSTANCES_TASKMENULIST = '/process/processInstance/getTaskMenuList/:processServiceId';
export const API_PROCESS_INSTANCES_CURRENTTASKLIST = '/process/processInstance/getProcessCurrentTasks/:processInstanceId';
export const API_PROCESS_INSTANCES_SUSPEND = '/process/processInstance/suspendProcessInstance/:instanceId';
export const API_PROCESS_INSTANCES_ACTIVITE = '/process/processInstance/activiteProcessInstance/:instanceId';
export const API_PROCESS_INSTANCES_TERMINAL = '/process/processInstance/terminalProcessInstance';
// 流程中心-时间管理
export const API_PROCESS_SERVICE_TIME_TEMPLATE_DETAIL = '/process/time/getServiceTimeTemplate/:id';
export const API_PROCESS_SERVICE_TIME_TREE_LIST = '/process/time/getServiceTimeTreeList';
export const API_PROCESS_SERVICE_TIME_TREE_SAVE = '/process/time/saveServiceTimeTree';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_SAVE = '/process/time/saveServiceTimeTemplate';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_UPDATE = '/process/time/updateServiceTimeTemplate';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_LIST = '/process/time/getServiceTimeTemplateList';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_DELETE = '/process/time/deleteServiceTimeTemplate/:id';
// export const API_PROCESS_SERVICE_TIME_TREE_UPDATE = '/process/time/updServiceTimeTree';
// export const API_PROCESS_SERVICE_TIME_TREE_DELETE = '/process/time/deleteServiceTimeTree/:id';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE = '/process/time/getServiceTimeTemplateInstance/:id';
export const API_PROCESS_SERVICE_TIME_TREE_INSTANCE_LIST = '/process/time/getServiceTimeTreeInstanceList';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE_SAVE = '/process/time/saveServiceTimeTemplateInstance';
export const API_PROCESS_SERVICE_TIME_TREE_NODE_DELETE = '/process/time/deleteServiceTimeTreeNode/:id';
export const API_PROCESS_SERVICE_TIME_INSTANCE_TREE_NODE_DELETE = '/process/time/deleteServiceTimeInstanceTreeNode/:id/:processInstanceId';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE_LIST = '/process/time/getServiceTimeTreeInstanceList';
export const API_PROCESS_SERVICE_TIME_TEMPLATE_INSTANCE_MODELFORMS = '/process/time/getTimeTemplateInstanceForms';
// 资源管理
export const API_RESOURCE_LIST = '/system/resource/getResourceList';
export const API_RESOURCE_TREE_LIST = '/system/resource/getResourceTreeList';
export const API_RESOURCE_TREE_DRAG = '/system/resource/dragResourceTree';
export const API_RESOURCE_DETAIL = '/system/resource/getResource/:resourceId';
export const API_RESOURCE_SAVE = '/system/resource/saveResource';
export const API_RESOURCE_DELETE = '/system/resource/deleteResource/:resourceId';

// 角色管理
export const API_ROLE_LIST = '/system/role/getRoleList';
export const API_ROLE_DETAIL = '/system/role/getRole/:roleId';
export const API_ROLE_SAVE = '/system/role/saveRole';
export const API_ROLE_DELETE = '/system/role/deleteRole/:roleId';

// 分类树
export const API_BUSINESS_TREE_LIST = '/process/businessTree/getBusinessTreeList';
export const API_BUSINESS_TREE_LIST_NOCACHE = '/process/businessTree/getBusinessTreeListNoCache';
export const API_BUSINESS_TREE_SAVE = '/process/businessTree/saveBusinessTree';
export const API_BUSINESS_TREE_UPDATE = '/process/businessTree/updBusinessTree';
export const API_BUSINESS_TREE_DELETE = '/process/businessTree/deleteBusinessTree/:nodeId';
export const API_BUSINESS_TREE_DRAG = '/process/businessTree/dragBusinessTree';

// 应用商店业务分类树
export const API_CUSTOMER_BUSINESS_TREE_LIST = '/customer/businessTree/getCsBusinessTreeList';
export const API_CUSTOMER_BUSINESS_TREE_SAVE = '/customer/businessTree/saveCsBusinessTree';
export const API_CUSTOMER_BUSINESS_TREE_UPDATE = '/customer/businessTree/updCsBusinessTree';
export const API_CUSTOMER_BUSINESS_TREE_DELETE = '/customer/businessTree/deleteCsBusinessTree/:nodeId';
export const API_CUSTOMER_BUSINESS_TREE_DRAG = '/customer/businessTree/dragCsBusinessTree';

// 字典树
export const API_DICTIONARY_TREE_LIST = '/component/dictionary/getDictionaryTreeList';
export const API_DICTIONARY_TREE_SAVE = '/component/dictionary/saveDictionaryTree';
export const API_DICTIONARY_TREE_UPDATE = '/component/dictionary/updDictionaryTree';
export const API_DICTIONARY_TREE_DELETE = '/component/dictionary/deleteDictionaryTree/:nodeId';
export const API_DICTIONARY_TREE_DRAG = '/component/dictionary/dragDictionaryTree';

// 应用商店字典树
export const API_CUSTOMER_DICTIONARY_TREE_LIST = '/customer/dictionary/getCsDictionaryTreeList';
export const API_CUSTOMER_DICTIONARY_TREE_SAVE = '/customer/dictionary/saveCsDictionaryTree';
export const API_CUSTOMER_DICTIONARY_TREE_UPDATE = '/customer/dictionary/updCsDictionaryTree';
export const API_CUSTOMER_DICTIONARY_TREE_DELETE = '/customer/dictionary/deleteCsDictionaryTree/:nodeId';
export const API_CUSTOMER_DICTIONARY_TREE_DRAG = '/customer/dictionary/dragCsDictionaryTree';

// 流水号树
export const API_SERIALNUMBER_CHECK_IF_EXIST = '/component/serialNumber/checkSerialNumberIfExist/:serialNumber';
export const API_SERIALNUMBER_TREE_LIST = '/component/serialNumber/getSerialNumberTreeList';
export const API_SERIALNUMBER_NOW = '/component/serialNumber/getSerialNumber/:id';
export const API_SERIALNUMBER_NOW_PRIVATE1 = '/component/serialNumber/getSerialNumber/:id/:busiId/:departId';// 个性化1;
export const API_SERIALNUMBER_NOW_PRIVATE2 = '/component/serialNumber/getSerialNumber/:instanceId/:serialNumberRefId/:serialNumberRelationFormId/:serialNumberRelationFieldId';// 个性化2;
export const API_SERIALNUMBER_NOW_PRIVATE3 = '/component/serialNumber/getSerialNumberDepAndOption/:id/:departId/:configOptionId';// 个性化3;
export const API_SERIALNUMBER_NOW_DEPARTMENT = '/component/serialNumber/getSerialNumberDepartment';
export const API_SERIALNUMBER_NOW_PLUS = '/component/serialNumber/getSerialNumberPlus';
export const API_SERIALNUMBER_NOW_UPDATESERIALNUMBERSTATE = '/component/serialNumber/upDateSerialNumberState';
export const API_SERIALNUMBER_STATUS = '/component/serialNumber/getNumberStatus';
export const API_SERIALNUMBER_TREENODE = '/component/serialNumber/getTree/:id';

export const API_SERIALNUMBER_TREE_SAVE = '/component/serialNumber/saveSerialNumberTree';
export const API_SERIALNUMBER_TREE_UPDATE = '/component/serialNumber/updSerialNumberTree';
export const API_SERIALNUMBER_TREE_DELETE = '/component/serialNumber/deleteSerialNumberTree/:nodeId';
export const API_SERIALNUMBER_TREE_DRAG = '/component/serialNumber/dragSerialNumberTree';
export const API_SERIALNUMBER_DELETE = '/component/serialNumber/deleteSerialNumber/:id';
export const API_SERIALNUMBER_UPDATEREFSERIALNUMBER = '/component/serialNumber/updateRefSerialNumber/:id';

// 应用商店流水号树
export const API_CUSTOMER_SERIALNUMBER_TREE_LIST = '/customer/serialNumber/getCsSerialNumberTreeList';
export const API_CUSTOMER_SERIALNUMBER_NOW = '/customer/serialNumber/getCsSerialNumber/:id';
export const API_CUSTOMER_SERIALNUMBER_STATUS = '/customer/serialNumber/getCsNumberStatus';
export const API_FORM_APPROVE_CONFIG = '/component/customForm/getApproveData';
export const API_CUSTOMER_SERIALNUMBER_TREE_SAVE = '/customer/serialNumber/saveCsSerialNumberTree';
export const API_CUSTOMER_SERIALNUMBER_TREE_UPDATE = '/customer/serialNumber/updCsSerialNumberTree';
export const API_CUSTOMER_SERIALNUMBER_TREE_DELETE = '/customer/serialNumber/deleteCsSerialNumberTree/:nodeId';
export const API_CUSTOMER_SERIALNUMBER_TREE_DRAG = '/customer/serialNumber/dragCsSerialNumberTree';
export const API_CUSTOMER_SERIALNUMBER_DELETE = '/customer/serialNumber/deleteCsSerialNumber/:id';

// 应用配置树
export const API_APPLICATION_TREE_LIST = '/application/applicationTree/getApplicationTreeList';
export const API_APPLICATION_TREE_SAVE = '/application/applicationTree/saveApplicationTree';
export const API_APPLICATION_TREE_UPDATE = '/application/applicationTree/updApplicationTree';
export const API_APPLICATION_TREE_DELETE = '/application/applicationTree/deleteApplicationTree/:nodeId';
export const API_APPLICATION_TREE_DRAG = '/application/applicationTree/dragApplicationTree';
export const API_APPLICATION_LIST = '/application/applicationTree/getApplicationLimit';

// 应用描述
export const API_APPLICATION_DESCRIBER = '/application/applicationTree/getAppDescribeById/:appId';

// 模型设置
export const API_PUBLISHED_APPLICATION_LIST = '/application/model/getPublishedApplicationList';
export const API_PUBLISHEDAPPLICATIONPARENTLIST = '/application/model/getPublishedApplicationParentList';
export const API_PUBLISHED_MODELBYAPPID_LIST = '/application/model/getPublishedModelbyAppIdList';
export const API_APPLICATION_MODEL_LIST = '/application/model/getModelServiceList';
export const API_APPLICATION_MODEL_DETAIL = '/application/model/getModelService/:modelId';
export const API_APPLICATION_MODEL_SAVE = '/application/model/saveModelService';
export const API_APPLICATION_MODEL_DELETE = '/application/model/delModelService';
export const API_APPLICATION_MODEL_SORT_SAVE = '/application/model/saveModelServiceSortOrder';

export const API_APPLICATION_MODEL_USERAUTH = '/application/model/getApplicationModelUserAuth';
export const API_APPLICATION_MODEL_SAVE_USERAUTH = '/application/model/saveApplicationModelUserAuth';
export const API_APPLICATION_MODEL_DELETE_USERAUTH = '/application/model/delApplicationModelUserAuth/:ids/:users/:formId';
export const API_APPLICATION_MODEL_DATAAUTH = '/application/model/getApplicationModelDataAuth';
export const API_APPLICATION_MODEL_SAVE_DATAAUTH = '/application/model/saveApplicationModelDataAuth';
export const API_APPLICATION_MODEL_DELETE_DATAAUTH = '/application/model/delApplicationModelDataAuth/:ids';

// 发布应用
export const API_APPLICATION_PUBLISH = '/application/model/publishApp';
export const API_APPLICATION_UNPUBLISH = '/application/model/unpublishApp';

// 回显 应用 被授权的数据
export const API_QUEY_APPLICATION_GRANTAUTHORIZATION_USERS = '/application/model/queyApplicationGrantAuthorizationUsers';

// 复制模型
export const API_COPY_CUSTOMBYID = '/component/customForm/copyCustomFormById';
// 移动表单模型
export const API_TRANSFER_CUSTOMBYID = '/component/customForm/transferCustomFormById';

export const API_APPLICATION_ASSIGN_LIST = '/application/model/getAppAssignList';
export const API_FORM_AUTH_BY_MODELID = '/application/model/getFormAuthByModelId';
export const API_APPLICATION_UNASSIGN_LIST = '/application/model/getAppUnAssignList';
export const API_APPLICATION_MODELMENU_LIST = '/application/model/getApplicationModelMenuList';
export const API_APPLICATION_MODEL_ALLMENU_LIST = '/application/model/getApplicationModelAllMenuList';
export const API_APPLICATION_MODELTREE_LIST = '/application/model/getApplicationModelTreeList';

export const API_APPLICATION_MODEL_PUBLISH = '/application/model/:modelId/publish';
export const API_APPLICATION_MODEL_BATH_PUBLISH = '/application/model/:appId/publishByAppId';
export const API_APPLICATION_MODEL_FORM_DETAIL = '/application/model/getModelFormById/:modelId';
export const API_APPLICATION_MODEL_FORM_GET_MODEL_FORM_BY_DRAFT = '/application/model/getModelFormByDraft';
export const API_SAVE_APPLICATION_MODEL_FORM = '/application/model/saveAppModelForm/:modelId';
export const API_SAVE_APPLICATION_CHECKDATALEGITIMACY = '/component/customForm/checkDataLegitimacy';
export const API_MODEL_FORM_REPORTLIST_LIST = '/application/model/getModelFormReportList';
export const API_TABEL_COLUMNS_BY_FORMID = '/application/model/getTableColumnsByFormId'; // 查询表头信息
export const API_GET_FORM_COLUMNS_BY_FORMID = '/application/model/getFormColumnsByFormId'; // 获取表单的列
export const API_APPLICATION_MODEL_FORM_INSTANCE_DETAIL = '/application/model/getModelFormInstanceById/:instanceId';
export const API_APPLICATION_MODEL_FORM_INSTANCE_DETAIL_TO_LIKN = '/application/model/getModelFormInstanceByIdToLink';
export const API_APPLICATION_MODEL_FORM_INSTANCE_PROCESS_DETAIL = '/application/model/getModeInstanceProcessDetail';
export const API_MODEL_FORM_GETMODELFORMINSTANCEQR = '/application/model/getModelFormInstanceQR';
export const API_APPLICATION_MODELFORMINSTATNCE_DELETE = '/application/model/delModelFormInstance';
export const API_EXPORT_MODEL_FORM_EXCEL = `${conf.baseURL}/excel/exportExcelData/?modelId=:modelId&selectedFields=:selectedFields&approvalInstanceId=:approvalInstanceId&searchCondition=:searchCondition&isApprovalForm=:isApprovalForm&needSumData=:needSumData&processInstanceId=:processInstanceId&isAllData=false&needLinkSelectField=false`;
export const API_EXPORT_MODEL_TITLE_FORM_EXCEL = `${conf.baseURL}/excel/exportExcelTitle/?modelId=:modelId`;
export const API_EXPORT_MODEL_GET_EXCEL_EXPORTID = '/excel/getExcelDataExportId';
export const API_COMMON_EXPORT_MODEL_GET_EXCEL_EXPORTID = '/excel/getExcelCommonDataExportId';
export const API_EXPORT_MODEL_EXPORT_EXCEL_BY_EXPORTID = `${conf.baseURL}/excel/exportExcelByExportId/?exportId=:exportId`;
export const API_EXPORT_MODEL_EXPORT_PROCESS_EXCEL_BY_EXPORTID = `${conf.baseURL}/excel/exportProcessExcelByExportId/?exportId=:exportId`;
export const API_EXPORT_MODEL_EXPORT_TASK_EXCEL_BY_EXPORTID = `${conf.baseURL}/excel/exportTaskExcelByExportId/?exportId=:exportId`;
export const API_APPLICATION_MODEL_IMPORT_FORM_EXCEL = '/application/model/importData';
export const API_SYNCPROCESSDATA = '/application/model/syncProcessData/';
export const API_APPLICATION_MODEL_FORM_GET_CROSSFIELD_DATA = '/application/model/getCrossFieldData';

export const API_APPLICATION_MODEL_FORM_DETAIL_HISTORY = '/application/model/getModelFormHistoryById/:modelId';

// 定时任务管理
export const API_CRONJOB_LIST = '/application/cronjob/getCronjobList';
export const API_CRONJOB_DETAIL = '/application/cronjob/getCronjob/:id';
export const API_CRONJOB_SAVE = '/application/cronjob/addCronJob';
export const API_CRONJOB_UPDATE = '/application/cronjob/updCronJob';
export const API_CRONJOB_DELETE = '/application/cronjob/deleteCronJob/:id';
export const API_CRONJOB_ADDSCHEDULESTART = '/application/cronjob/addScheduleStart';
export const API_CRONJOB_ADDSCHEDULEPAUSE = '/application/cronjob/addSchedulePause';
export const API_CRONJOB_ADDSCHEDULERESUME = '/application/cronjob/addScheduleResume';

// 角色资源配置
export const API_AUTHORITY_LIST = '/system/roleResource/getResourceListByRoleId';
export const API_AUTHORITY_DELETE = '/system/roleResource/deleteRoleResource/:roleResourceId';
export const API_AUTHORITY_SAVE = '/system/roleResource/saveMultRoleResource';
export const API_RESOURCE_NOTIN_ROLE_LIST = '/system/roleResource/getResourceListNotInRole';

// 组织机构树
export const API_ORGANIZATION_TREE = '/system/department/getDepartmentTree';
// 根据部门ID获取其下员工列表
export const API_ORGANIZATION_LIST = '/system/employee/getEmployeeListByDepartmentId';
// 删除部门员工关系
export const API_ORGANIZATION_DELETE = '/system/employee/deleteEmployeeDepartment/:id';
// 新增部门员工关系
export const API_ORGANIZATION_SAVE = '/system/employee/saveMultEmployeeDepartment';
// 根据未分配部门的员工列表
export const API_EMPLOYEE_ONTIN_DEPARTMENT_LIST = '/system/employee/getEmployeeListNotInDept';

// 日志
export const API_LOG_LIST = '/system/log/getAccessLogList';

// 根据岗位ID获取其下员工列表
export const API_POSITIONASSIGN_LIST = '/system/employee/getEmployeeListByPositionId';
// 删除岗位员工关系
export const API_POSITIONASSIGN_DELETE = '/system/employee/deleteEmployeePosition/:id';
// 新增岗位员工关系
export const API_POSITIONASSIGN_SAVE = '/system/employee/saveMultEmployeePosition';
// 获取员工的扩展字段ID
export const API_GET_USEREXTENDDATAIDS = '/system/employee/getUserExtendDataIds';
// 根据未分配岗位的员工列表
export const API_EMPLOYEE_ONTIN_POSITION_LIST = '/system/employee/getEmployeeNotInPositionList';

// 根据角色ID获取其下员工列表
export const API_ROLEASSIGN_LIST = '/system/employee/getEmployeeListByRoleId';
// 删除角色员工关系
export const API_ROLEASSIGN_DELETE = '/system/employee/deleteEmployeeRole/:id';
// 新增角色员工关系
export const API_ROLEASSIGN_SAVE = '/system/employee/saveMultEmployeeRole';
// 根据未分配角色的员工列表
export const API_EMPLOYEE_ONTIN_ROLE_LIST = '/system/employee/getEmployeeNotInRoleList';

// 消息中心
export const API_MESSAGE_CENTER_LIST = '/message/getMessageList';
export const API_MESSAGE_CENTER_UPDATE = '/message/updMessage';
export const API_MESSAGE_CENTER_DELETE = '/message/deleteMessage/:msgId';
export const API_MESSAGE_CENTER_GETMESSAGE = '/message/getMessage/:msgId';
export const API_MESSAGE_CENTER_URGE_MESSAGE_ADD = '/message/sendUrgeMessage';
export const API_MESSAGE_CENTER_URGE_MESSAGE_SEND_LIST = '/message/getUrgeMessageList';
export const API_MESSAGE_CENTER_URGE_MESSAGE_DELETE = '/message/delUrgeMessageBO';

// 标签管理
export const API_TAG_LIST = '/file/getTags';
export const API_TAG_ADD = '/file/addTag';
export const API_TAG_DELETE = '/file/deleteTag/:id';
export const API_FILE_DESC_UPDATE = '/file/updateFileDesc';

// 文档中心
// 公用文库
export const API_DOCUMENT_PUBLICLIBRARY_GET_FILES = '/document/publicLibrary/getFiles';
export const API_DOCUMENT_PUBLICLIBRARY_UPLOAD_FILE = '/document/publicLibrary/uploadFile';
export const API_DOCUMENT_PUBLICLIBRARY_UPDSHAREINNER = '/document/publicLibrary/updShareInner';
export const API_DOCUMENT_PUBLICLIBRARY_ADDMOVEFILE = '/document/publicLibrary/addMoveFile';
// 获取文件夹及文件树
export const API_DOCUMENT_PUBLICLIBRARY_GET_FILELIST = '/document/publicLibrary/getPublicFileList';
// 公用文库树
export const API_PUBLICLIBRARY_TREE_LIST = '/document/publicLibrary/getPublicLibraryTreeList';
export const API_PUBLICLIBRARY_TREE_SAVE = '/document/publicLibrary/savePublicLibraryTree';
export const API_PUBLICLIBRARY_TREE_UPDATE = '/document/publicLibrary/updPublicLibraryTree';
export const API_PUBLICLIBRARY_TREE_DELETE = '/document/publicLibrary/deletePublicLibraryTree/:nodeId';
export const API_PUBLICLIBRARY_TREE_DRAG = '/document/publicLibrary/dragPublicLibraryTree';
export const API_PUBLICLIBRARY_FILE_DELETE = '/document/delete/file';

// 文件标签树
export const API_FILETAGS_TREE_LIST = '/document/fileTags/getFileTagsTreeList';
export const API_FILETAGS_TREE_SAVE = '/document/fileTags/saveFileTagsTree';
export const API_FILETAGS_TREE_UPDATE = '/document/fileTags/updFileTagsTree';
export const API_FILETAGS_TREE_DELETE = '/document/fileTags/deleteFileTagsTree/:nodeId';
export const API_FILETAGS_TREE_DRAG = '/document/fileTags/dragFileTagsTree';

// 业务档案
export const API_FILETAGS_ARCHIVETEMPLATE_TREE_LIST = '/archive/getFileTagsArchiveTemplateTreeList';
export const API_ARCHIVE_MERGE_ARCHIVE_FILE = '/archive/mergeArchiveFile';
export const API_ARCHIVE_APPLY_ARCHIVE_FILE = '/archive/applyArchiveFile';
export const API_ARCHIVE_APPROVAL_ARCHIVE_FILE = '/archive/approvalArchiveFile';
export const API_ARCHIVE_SAVE_ARCHIVENO = '/archive/saveArchiveNo';
export const API_EXPORT_ARCHIVE_DIR_EXCEL = `${conf.baseURL}/excel/exportArchiveDirExcel/?templateId=:templateId&processInstanceId=:processInstanceId&hasChildFiles=:hasChildFiles&processInstanceName=:processInstanceName&processInstanceArchiveNo=:processInstanceArchiveNo`;
export const API_EXPORT_FORM_ARCHIVE_DIR_EXCEL = `${conf.baseURL}/excel/exportArchiveDirExcel/?templateId=:templateId&processInstanceId=:processInstanceId&hasChildFiles=:hasChildFiles&modelInstanceId=:modelInstanceId`;
export const API_ARCHIVE_FOLDER_FILE_DOWNLOAD = `${conf.baseURL}/archive/packingDownloadFiles/?templateId=:templateId&processInstanceId=:processInstanceId&archiveFolderId=:archiveFolderId&archiveFolderName=:archiveFolderName`;
export const API_ARCHIVE_SINGLE_APPLY_ARCHIVE_FILE = '/archive/applySingleArchiveFileApply';
export const API_ARCHIVE_SINGLE_APPLY_ARCHIVE_FILE_DEL = '/archive/delSingleArchiveFileApprovalApply';
export const API_ARCHIVE_APPROVAL_ARCHIVE_FILE_BYIDS = '/archive/approvalArchiveFileByIds';
// 文档中心-档案模板
export const API_ARCHIVE_TEMPLATE_LIST = '/document/archiveTemplate/getArchiveTemplateList';
export const API_ARCHIVE_TEMPLATE_DETAIL = '/document/archiveTemplate/getArchiveTemplate/:id';
export const API_ARCHIVE_TEMPLATE_SAVE = '/document/archiveTemplate/saveArchiveTemplate';
export const API_ARCHIVE_TEMPLATE_DELETE = '/document/archiveTemplate/delArchiveTemplate';
export const API_ARCHIVE_TEMPLATE_PUBLISH = '/document/archiveTemplate/:id/:state/publish';
export const API_ARCHIVE_TEMPLATE_SAVE_COPY = '/document/archiveTemplate/saveCopyArchiveTemplate';

// 文档中心-档案模板树
export const API_ARCHIVE_TEMPLATE_GET_FILES = '/document/archiveTemplate/getFiles';
export const API_ARCHIVE_TEMPLATE_TREE_LIST = '/document/archiveTemplateTree/getArchiveTemplateTreeList';
export const API_ARCHIVE_TEMPLATE_TREE_SAVE = '/document/archiveTemplateTree/saveArchiveTemplateTree';
export const API_ARCHIVE_TEMPLATE_TREE_UPDATE = '/document/archiveTemplateTree/updArchiveTemplateTree';
export const API_ARCHIVE_TEMPLATE_TREE_DELETE = '/document/archiveTemplateTree/deleteArchiveTemplateTree/:nodeId';
// export const API_ARCHIVE_TEMPLATE_TREE_DRAG = '/document/archiveTemplateTree/dragArchiveTemplateTree';
export const API_ARCHIVE_TEMPLATE_FILE_DELETE = '/document/delete/archiveFile';
export const API_ARCHIVE_TEMPLATE_FILE_ADDMOVEFILE = '/document/archiveTemplateTree/addMoveFile';

export const API_ARCHIVE_TEMPLATE_GET_INSTANCE_FILES = '/document/archiveTemplate/getInstanceFiles';
export const API_CUSTOMFORM_GETMODELFORMDETAIL = '/component/customForm/getModelFormDetail';

export const API_ARCHIVE_TEMPLATE_TREE_INSTANCE_LIST = '/document/archiveTemplateTree/getArchiveTemplateInstanceTreeList';
export const API_ARCHIVE_TEMPLATE_FILE_INSTANCE_DELETE = '/document/delete/archiveInstanceFile';
export const API_DOCUMENT_ARCHIVE_TEMPLATE_UPLOAD_FILE = '/document/archiveTemplate/uploadFile';
export const API_DOCUMENT_ARCHIVE_TEMPLATE_COPY_FILE = '/document/archiveTemplate/copyFileToTarget';
export const API_ARCHIVE_TEMPLATE_TREE_INSTANCE_SAVE = '/document/archiveTemplateTree/saveArchiveTemplateInstanceTree';
export const API_ARCHIVE_TEMPLATE_FILE_INSTANCE_SAVE = '/document/archiveTemplate/saveArchiveInstanceFile';
export const API_FILES_LIST_BY_TEMPLATE_TREE_ID = '/document/archiveTemplateTree/getFilesListByTemplateTreeId';
// 客服管理
export const API_COMPANY_ADD_CONFIGRESOURCE = '/system/company/configResource';
export const API_SYSTEM_GET_SYSTEMCONFIG = '/system/gloabal/getSystemConfig';
export const API_SYSTEM_CONFIG_BASEINFO = '/system/gloabal/configSystemBaseInfo';
export const API_SYSTEM_LOAD_DASHBOARD_IN_CACHE = '/system/gloabal/loadDashBoardInCache';
export const API_SYSTEM_SYNC_FORMDATA_CACHE = '/system/gloabal/syncFormDataCache';
export const API_SYSTEM_RELOAD_CROSSFORM_RELATION_DATA = '/system/gloabal/reloadCrossFormRelationData';
export const API_SYSTEM_CLEANREDISCACHE = '/system/cleanRedisCache';
export const API_SYSTEM_UPDGZDDATA = '/system/updGzdData';
export const API_SYSTEM_CLEANFORMDATA = '/system/cleanFormData';
export const API_SYSTEM_UPDUSERREFDATA = '/system/updUserRefData';
export const API_SYSTEM_UPD_APPROVAL_SUCCESS_INFO = '/system/updApprovalSuccessInfo';
export const API_SYSTEM_SELECTCACHEBITABLES = '/system/selectCacheBITablesInfo';
export const API_SYSTEM_DELETETEMPTABLE = '/system/deleteTempTable';
export const API_SYSTEM_SYNC_APPROVE_DATE = '/system/syncApproveDate';
export const API_SYSTEM_DELETE_ALL_TEMPTABLE = '/system/deleteAllTempTable';
export const API_SYSTEM_SETFORMDATAREDISMODE = '/system/setFormDataRedisMode';

export const API_MESSAGE_TEMPLATE_LIST = '/messageTemplate/getMessageTemplateList';
export const API_MESSAGE_TEMPLATE_DETAIL = '/messageTemplate/getMessageTemplate/:messageTemplateId';
export const API_MESSAGE_TEMPLATE_SAVE = '/messageTemplate/saveMessageTemplate';
export const API_MESSAGE_TEMPLATE_DELETE = '/messageTemplate/deleteMessageTemplate/:messageTemplateId';

export const API_COMPANY_MESSAGE_TEMPLATE_LIST = '/messageTemplateReceiver/getCompanyMessageTemplateList';
export const API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_IN_LIST = '/messageTemplateReceiver/getMessageTemplateReceiverInList';
export const API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_NOTIN_LIST = '/messageTemplateReceiver/getMessageTemplateReceiverNotInList';
export const API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_DELETE = '/messageTemplateReceiver/delMsgReceiver/:id';
export const API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_SAVA = '/messageTemplateReceiver/saveMultMsgReceiver';

export const API_MESSAGE_WARN_LIST = '/message/getWarnMessageList';

// 应用商店树
export const API_APPSTORE_TREE_LIST = '/component/appstore/getAppstoreTreeList';
export const API_APPSTORE_APP_TREE_LIST = '/component/appstore/getAppstoreAppTreeList/:appId';
export const API_APPSTORE_APP_LIST = '/component/appstore/getAppListFromStoreByTreeNode';
export const API_APPSTORE_APP_CHECKSTATE_UPDE = '/component/appstore/updAppCheckState';// 审核应用
export const API_APPSTORE_APP_DELETE = '/component/appstore/deleteAppFromStore/:id';// 删除应用
export const API_APPSTORE_APP_PUSH_TO_STORE = '/component/appstore/addCopyAppToStoreByAppId';// 推送应用
export const API_APPSTORE_APP_MODELMENU_LIST = '/component/appstore/getApplicationModelMenuListFromStore';
export const API_APPSTORE_APP_MODEL_LIST = '/component/appstore/getModelServiceListFromStore';
export const API_APPSTORE_APP_FORM_TEMPLATE_DETAIL = '/component/appstore/getFormConfigFromStore';
export const API_APPSTORE_APP_DOWN_FROM_STORE = '/component/appstore/downAppFromAppstoreByAppId';// 下载应用

export const API_APPSTORE_APP_MODELTREE_LIST = '/component/appstore/getApplicationModelTreeListFromStore';
export const API_APPSTORE_APP_MODEL_DETAIL = '/component/appstore/getModelServiceFromStore/:modelId';
export const API_APPSTORE_APP_MODEL_DETAIL_BYID = '/component/appstore/getModelFormByIdFromStore/:modelId';
export const API_APPSTORE_MODEL_FORM_REPORTLIST_LIST = '/component/appstore/getModelFormReportListFromStore';

// 客服中心-流程管理
export const API_APPSTORE_PROCESS_UPLOAD_TEMPLATE = '/component/process/uploadFile';

// 推送给客服系统
export const API_BUSINESS_TREE_PUSH_TO_CS = '/process/businessTree/copyBusinessTreeToCS';
export const API_DICTIONARY_TREE_PUSH_TO_CS = '/component/dictionary/copyDictionaryTreeToCs';
export const API_SERIALNUMBER_TREE_PUSH_TO_CS = '/component/serialNumber/copySerialNumberTreeToCs';

// 查看应用介绍
export const API_APPSTORE_APP_DES = '/component/appstore/getAppStoreAppDescribe/:appId';
export const API_APPSTORE_APP_DES_INSERT = '/component/appstore/insertAppStoreAppDescribe';
export const API_APPSTORE_APP_DES_UPD = '/component/appstore/updAppStoreAppDescribe';

// 复制档案模板给客服
export const API_ARCHIVE_TEMPLATE_COPY_TO_CS = '/document/archiveTemplate/copyArchiveTemplateToCs';

// 电子签章的参数构造
export const API_SET_SIGNATURE_RECORDPARAM = '/document/signature/setSignatureRecordParam';
// 电子签章的文件签章记录
export const API_GET_SIGNATURE_RECORD = '/document/signature/getSignatureRecord';
// 电子签章的文件签章记录
export const API_GET_SIGNATURE_FILE_RECORD = '/document/signature/getSignatureFileRecord';
// 电子签章中获取
export const GET_PROCESS_TASK_INFO = '/document/signature/getProcessTaskInfo';
// 获取文件的打印次数
export const GET_GETFILE_PRINTTIMES = '/document/signature/getFilePrintTimes';
// 获取增加文件的打印次数配置
export const GET_ADD_FILE_PRINT_TIMES = '/document/signature/addFilePrintTimes';

// 忘记密码
export const API_LOGIN_FORGET_PWD_SEND_SMS = '/cs/user/getSMSForForgetPwd';
export const API_LOGIN_FORGET_PWD_UPD_PWD = '/cs/user/updUserPwdForReset';

// 注册发送验证码
export const API_LOGIN_REGISTER_SEND_SMS = '/cs/user/getSMSForRegister';

// 获取验证码key
export const API_LOGIN_CREATE_IMAGE_CODE_KEY = '/cs/user/getCreateImageCodeKey';

// 业务分布BI图
export const API_OPERATION_APPROVAL_TIME_RATIO = '/operation/state/getApprovalTimeRatio';
export const API_OPERATION_APPROVAL_STATE_INFO_LIST = '/operation/state/getApprovalProcessInfoForBI';
export const API_OPERATION_APPROVAL_STATE_LIST = '/operation/state/getApproveInstancesStateList/:busiType';
export const API_OPERATION_PROCESS_TOTEL_INFO = '/operation/state/getTotalInfo/:busiType';
export const API_OPERATION_PROCESS_INFO = '/operation/state/getProcessInfo';
// export const API_OPERATION_PROCESS_INFO = '/operation/state/getProcessInfo/:busiTypes/:state';
export const API_OPERATION_USER_REAL_TIME_STATE = '/operation/state/getUserRealtimeState';
export const API_OPERATION_USER_REAL_TIME_DETAIL_STATE = '/operation/state/getUserRealtimeDetailState/:userId';

export const API_OPERATION_TIME_GANTT = '/operation/state/getTimeGantt/:processInstanceId';
export const API_OPERATION_TIME_GANTT_FOR_COMPARE = '/operation/state/getTimeGanttForCompare/:processInstanceId';
export const API_OPERATION_PLAN_TIME_GANTT = '/operation/state/getPlanTimeGantt/:processInstanceId';
export const API_OPERATION_PROCESS_TIME_TREE_LIST = '/operation/state/getProcessTimeTreeList';
export const API_OPERATION_ALL_PROCESS_INSTANCE_LIST = '/operation/state/getAllProcessInstanceList';
export const API_OPERATION_PROCESS_ADJ_TREE_LIST = '/operation/state/getProcessAdjTreeList';
export const API_OPERATION_PROCESS_CACHE_DATA_BY_ID = '/operation/state/getProcessCacheDataById';

export const API_OPERATION_BCBPM_PROCESS_INSTNCE_LIST = '/operation/state/getBcbpmProcessInstanceList';
export const API_OPERATION_BCBPM_PROCESS_INSTNCE_BI = '/operation/state/getBcbpmProcessInstanceBICnt';
export const API_OPERATION_BCBPM_LOGIN_INFO_LIST_BI = '/operation/state/getLoginInfoListBIByTenantId';
// 员工特殊资源授权
export const API_EMPLOYEE_LIST_BY_RESOURCEID = '/system/employeeResource/getEmployeeListByResourceId';
export const API_EMPLOYEE_RESOURCE_DELETE = '/system/employeeResource/deleteEmployeeResource/:id';
export const API_MULT_EMPLOYEE_RESOURCE_SAVE = '/system/employeeResource/saveMultEmployeeResource';
export const API_EMPLOYEE_LIST_OF_UNAUTH_RES = '/system/employeeResource/getEmployeeListOfUnAuthRes';

// 体验应用传参
export const API_APPSTORE_ENCRYPT_TENANTID = '/component/appstore/getEncryptTenantId';

// 应用商店标签查询
export const API_APPSTORE_APP_TYPE_LIST = '/component/appType/getAppTypeList';
export const API_APPSTORE_APP_DES_OF_STOR = '/component/appstore/getAppStoreAppDescribeOfStore/:appId';

// 批量导入员工信息
export const API_EMPLOYEE_IMPORT_FORM_EXCEL = '/system/employee/importEmployeeData';

// 流程中心-闭环模板
export const API_PROCESS_CLOSE_TEMPLATE_SAVE = '/process/close/saveProcessCloseTemplate';
export const API_PROCESS_CLOSE_TEMPLATE_UPDATE = '/process/close/updProcessCloseTemplate';
export const API_PROCESS_CLOSE_TEMPLATE_LIST = '/process/close/getProcessCloseTemplateList';
export const API_PROCESS_CLOSE_TEMPLATE_DELETE = '/process/close/delProcessCloseTemplate/:id';
export const API_PROCESS_INSTANCE_CLOSE_TEMPLATE_SAVE = '/process/close/saveProcessInstanceCloseTemplate';

export const API_PROCESS_CLOSE_TEMPLATE_TASK_SAVE = '/process/close/saveProcessCloseTemplateTask';
export const API_PROCESS_CLOSE_TEMPLATE_TASK_UPDATE = '/process/close/updProcessCloseTemplateTask';
export const API_PROCESS_CLOSE_TEMPLATE_TASK_LIST = '/process/close/getProcessCloseTemplateTaskList';
export const API_PROCESS_CLOSE_TEMPLATE_TASK_DELETE = '/process/close/delProcessCloseTemplateTask/:id';
export const API_PROCESS_CLOSE_TEMPLATE = '/process/close/getProcessInstanceCloseTemplate/:processInstanceId/:id';
export const API_PROCESS_INSTANCE_CLOSE_TEMPLATE_TASK_DELETE = '/process/close/delProcessInstanceCloseTemplateTask/:id';

export const API_OPERATION_PROCESS_CLOSE_PROCESS_LIST = '/operation/state/getProcessListForCloseBI';
export const API_OPERATION_PROCESS_CLOSE_PROCESS_DETAIL = '/operation/state/getProcessDetailForCloseBI';

// 消息中心
export const API_MESSAGE_CENTER_ALL_MESSAGE_STATUS_UPDATE = '/message/updAllMessageStatus';
export const API_MESSAGE_CENTER_ALL_MESSAGE_DELETE = '/message/delAllReadMessage';

// 流程文件列表
export const API_PROCESS_INSTANCES_GET_PROCESSFILES = '/process/processInstance/getProcessFiles';
export const API_PROCESS_FILE_READ_RECORD_ADD = '/processFile/addProcessFileReadRecord';
export const API_PROCESS_FILE_UN_READ_CNT = '/process/processInstance/getProcessFileUnReadCnt';
export const API_PROCESS_FILE_ALL_UN_READ_TO_READ = '/process/processInstance/updProcessFileReadStatus';

export const API_APPSTORE_APP_PROCESS_DEFINITION_LIST = '/component/appstore/getStoreProcessDefinitionList';

export const API_APPLICATION_PROCESS_LIST = '/application/appProcess/getAppProcessList';
export const API_APPLICATION_PROCESS_DEFINITION_LIST_BY_ID = '/application/appProcess/getMyProcessDefinitionList';

// 考勤管理
export const API_ATTENDANCE_LIST = '/pc/attendance/queryClockInfoList';
export const API_WORKTIME_LIST = '/pc/attendance/getWorkTimeList';
export const API_WORKTIME_UPDATE = '/pc/attendance/updateWorkTime';
export const API_WORKTIME_DELETE = '/pc/attendance/deleteWorkTime/:id';
export const API_APPEAL_LIST = '/pc/attendance/getAppealClockList';
export const API_APPEAL_PASS = '/pc/attendance/passAppeal';
export const API_APPEAL_REJECT = '/pc/attendance/rejectAppeal';
export const API_ATTENDANCE_EXPORT_CLOCKLIST_TO_EXCEL = `${conf.baseURL}/pc/attendance/exportClockListToExcel/?startDate=:startDate&endDate=:endDate&userIds=:userIds&departmentId=:departmentId&currentPage=:currentPage&pageSize=:pageSize&clockStatus=:clockStatus`;
export const API_ATTENDANCE_EXPORT_CLOCK_SUMMARY_TO_EXCEL = `${conf.baseURL}/pc/attendance/exportOldClockSummaryToExcel/?startDate=:startDate&endDate=:endDate&tenantId=:tenantId`;

// 应用配置树
export const API_HELPCENTER_TREE_LIST = '/helpCenter/helpCenterTree/getHelpCenterTreeList';
export const API_HELPCENTER_CONTENT_LIST = '/helpCenter/helpCenterTree/getHelpCenterContentList';

// 公告管理
export const API_NOTICE_LIST = '/application/notice/getNoticeList';
export const API_GET_MANDATORY_REMINDER = '/application/notice/getMandatoryReminder';
export const API_SAVE_MANDATORY_REMINDER = '/application/notice/saveMandatoryReminder';
export const API_NOTICET_DETAIL = '/application/notice/getNoticeDetail/:id';
export const API_NOTICET_SAVE = '/application/notice/saveNotice';
export const API_NOTICET_DELETE = '/application/notice/deleteNotice/:id';
export const API_NOTICET_PUBLISHNOTICE = '/application/notice/publishNotice/:id';
export const API_NOTICET_PUBLISHCRONJOBNOTICE = '/application/notice/publishCronjobNotice';
export const API_NOTICET_GETNOTICEREADDETAIL = '/application/notice/getNoticeReadDetail';

// 组织机构树
export const API_ORG_TREE = '/system/department/getOrgList';
// 组织机构人员树
export const API_ORG_USER_TREE = '/process/businessTree/getOrgUserTree';
// 获取用户所有的表单
export const API_APPLICATION_GET_USER_FORMS = '/application/model/getUserModels';
// 获取企业部门数据权限数据结构
export const API_APPLICATION_GET_ORG_AUTH_LIST = '/system/department/getDepartmentListAuthData';
// 获取企业部门数据权限数据结构
export const API_APPLICATION_SAVE_BATCH_MODEL_DATA_AUTH = '/application/model/saveBatchApplicationModelDataAuth';

// 系统升级申请
export const API_USER_UPGRADE_APPLY = '/cs/user/upgradeSystemApply';

// 保存查询参数默认值
export const API_CONSTANT_MAP = '/system/constant/getConstantBOMap';
export const API_CONSTANT_DELETE = '/system/constant/deleteConstant/:method';
export const API_CONSTANT_PROCESS_TREEE_LIST_QRY_SAVE = '/system/constant/saveProcessTreeListQry';

// 表单消息配置
export const API_CUSTOM_FORM_EXTEND_TREE_LIST = '/component/customForm/getFormExtendTreeList';
export const API_CUSTOM_MSG_CONFIG_SAVE = '/component/customForm/saveFormMsgConfigBO';
export const API_CUSTOM_MSG_CONFIG_DELETE = '/component/customForm/deleteFormMsgConfigBO';
export const API_CUSTOM_MSG_CONFIG_GET = '/component/customForm/getFormMsgConfigBO';

// 报表树结构数据
export const API_MODEL_FORM_REPORT_TREE_GET = '/application/model/getModelFormReportTree';
export const API_MODEL_FORM_REPORT_ORG_TREE_GET = '/application/model/getModelFormReportOrgTree';

export const API_PROCESS_INSTANCE_FORM_CNT_GET = '/application/model/getProcessInstanceFormCnt';

// 企业应用复制到数据仓库
export const API_STORE_COMPONENT_COPY_RECORD_LIST = '/dataStore/getComponentCopyRecordList';
export const API_STORE_APP_COPY_RECORD_LIST = '/dataStore/getAppCopyRecordList';
export const API_STORE_APP_COPY_RECORD_DEL = '/dataStore/deleteAppCopyRecord/:id';
export const API_STORE_APP_COPY = '/dataStore/dataAppCopy';
export const API_STORE_COPY_BUSINESS_TREE = '/dataStore/copyBusinessTree';
export const API_STORE_COPY_DICTIONARY_TREE = '/dataStore/copyDictionaryTree';
export const API_STORE_COPY_SERIALNUMBER_TREE = '/dataStore/copySerialNumberTree';
export const API_STORE_COPY_ARCHIVE_TEMPLATE = '/dataStore/copyArchiveTemplate';
export const API_PROCESS_DEFINITION_CLONE_TO_TENANT = '/dataStore/processDefinitionCopyToTenant';
export const API_PROCESS_DEFINITION_CLONE_TO_TENANT_BY_APPID = '/dataStore/processCloneToTenantByAppId';
export const API_PROCESS_SERVICE_COPY_TO_TENANT_BY_APPID = '/dataStore/processServiceCopyByAppId';
export const API_PROCESS_SERVICE_PUBLIC_COPY_TO_TENANT_BY_APPID = '/dataStore/processServicePublic';
export const API_PROCESS_TEMPLATE_CONFIG_COPY_TO_TENANT_BY_APPID = '/dataStore/copyProcessTemplateConfig';
export const API_APPROVAL_TEMPLATE_COPY_TO_TENANT_BY_APPID = '/dataStore/approvalTemplateCopyByAppId/:appCopyRecordId';
export const API_STORE_APP_CASE_LIST = '/dataStore/getAppCaseList';
export const API_STORE_APP_CASE_LIMIT = '/dataStore/getAppCaseLimit';
export const API_STORE_FORM_DATA_COPY = '/dataStore/copyFormData';
// 应用方案一键全部复制接口
export const API_STORE_APP_CASE_COPY = '/dataStore/appCaseCopy';
export const API_STORE_DOWN_APP_CASE = '/dataStore/downAppCase';
// 工作助手
export const API_CUSTOM_GETFORMENTRY = '/component/customForm/getFormEntry';
export const API_CUSTOM_ADDFORMENTRY = '/component/customForm/addFormEntry';
export const API_MENU_USER_REMIND_NUM = '/message/getUserRemindNum';
export const API_ABOUT_ME_TOTAL_NUM = '/message/getAboutMeTotalNum';
// 获取企业模型菜单树 /getApplicationModelTreeMenu
export const API_APPLICATION_MODEL_TREE_MENU = '/application/model/getApplicationModelTreeMenu';
export const API_EMPLOYEE_ALL = '/system/employee/getEmployeeAll';
// 获取模型列表，按类型
export const API_MODEL_GET_MODEL_LIST_BY_TYPEE_GET = '/application/model/getModelListByType';
// 应用方案启用
export const API_DATASTORE_APP_ISENABLE_UPDE = '/application/applicationTree/updAppIsEnable';// 启用应用
export const API_DATASTORE_APP_INVISIBLE_COMPANYS_SAVE = '/application/applicationTree/saveAppCaseInvisibleCompanys';
// 批量发起流程
export const API_PROCESS_PUBLISHED_BATCH_START = '/process/processInstance/bathStartProcess';

// 流程常用配置负责人
export const API_PROCESS_COMMON_USE_CONFIG_DETAIL = '/process/config/getProcessCommonUseConfigBO/:id';
export const API_PROCESS_COMMON_USE_CONFIG_LIST = '/process/config/getProcessCommonUseConfigList';
export const API_PROCESS_COMMON_USE_CONFIG_SAVE = '/process/config/saveProcessCommonUseConfig';
export const API_PROCESS_COMMON_USE_CONFIG_DELETE = '/process/config/deleteServiceTimeTemplate/:id';
export const API_PROCESS_COMMON_USE_CONFIG_DELETE_BY_PROCESS_INSTANCE_ID = '/process/config/cancelProcessCommonUseConfigBOByProcesssId/:processInstanceId';

// 新版的流程树结构查询
export const API_PROCESS_INSTANCE_TREE_LIST = '/process/processInstance/getProcessInstanceTreeList';
export const API_PROCESS_INSTANCE_TREE_CHILDREN = '/process/processInstance/getProcessInstanceTreeChildren';

export const API_PROCESS_TASK_PROCESS_TREE_LIST = '/process/processInstance/getMenuProcessTreeList';

// 第三方人员信息获取
export const API_GET_AUTHENTICATION_USER_INFO = '/getAuthenticationUserInfo';

export const API_OPERATION_GET_LOGIN_INFO_LIST = '/operation/state/getLoginInfoList';
export const API_OPERATION_GET_USER_LOGIN_INFO_LIST = '/operation/state/getUserLoginInfoList';

// 表单文件
export const API_APPLICATION_GET_FORM_FIELES_LIST = '/application/model/getFormFilesList';
export const API_APPLICATION_GET_ARCHIVE_TEMPLATE_LIST_BY_FORMID = '/application/model/getArchiveTemplateListByFormId';
export const API_APPLICATION_GET_ARCHIVE_TEMPLATE_LIST_BY_TAGID = '/application/model/getArchiveTemplateListByTagId';

// 文件不可见任务配置
export const API_PROCESS_TASK_FILE_AUTH_VIEW_TASK_SAVE = '/process/task/saveTaskFileAuthViewConfig';
export const API_PROCESS_TASK_FILE_AUTH_VIEW_TASKLIST_GET = '/process/task/getTaskFileAuthViewList';

// 审批流文件共享给流程可见配置
export const API_APPROVAL_FILE_VIEW_FOR_PROCESS_BYIDS_DEL = '/approval/instance/delApprovalFileViewForProcessByIds';
export const API_APPROVAL_FILE_VIEW_FOR_PROCESS_BYIDS_ADD = '/approval/instance/addApprovalFileViewForProcessByIds';

// 表单数据修改记录
export const API_APPLICATION_FORM_DATA_UPD_RECORDBO_LIST = '/application/model/getFormDataUpdRecordBOList';

// 跨年统计属性字段值更新
export const API_APPLICATION_CROSS_COUNT_FIELD_DATA_UPD = '/application/model/updCrossCountFieldData';
export const API_APPLICATION_CROSS_COUNT_FIELD_CNT = '/application/model/getCrossCountFieldCnt';
export const API_APPLICATION_RPA_GENERATE_DATA = '/application/model/updRPARuleData';

// 获取流程指定表单的最新的一条未删除的数据记录
export const API_PROCESS_TASK_LAST_PROCESS_TASK_FORM_DATA = '/process/task/getLastProcessTaskFormData';

// 智能补全接口
export const API_APPLICATION_SINGLE_FIELD_DATA_LIST = '/application/model/getSingleFieldDataList';
// 党建单点登录
export const API_GET_PARTY_BUILDING_AUTHORIZE = '/api/oauth/getPartyBUildingAuthorize';
// 数据推送消息
export const API_SEND_MESSAGE_TO_USER = '/component/customForm/sendMessageToUser';

export const API_PROCESS_TASK_GET_REF_HIS_PROCESS_DATA = '/process/task/getRefHisProcessData';

export const API_CARBON_COPY_READ_UPD = '/approval/instance/updCarbonCopy';

export const API_SAVE_API_CONFIG = '/api/saveApiConfig';
export const API_GET_API_CONFIG_LIST = '/api/getApiConfigList';
export const API_PROCESS_TASK_CHECKREPORTREQUIRED = '/process/zxhzTask/checkReportRequired';
export const API_PROCESS_INSTANCES_POST_JUMPTASKPROCESSINSTANCES = '/process/task/dealJumpNextTask';
export const API_MAP_SUGGESTIONSEARCH = '/pc/attendance/suggestionSearch';
export const API_MAP_CONTRARYCONVERTGEOCODER = '/pc/attendance/contraryConvertGeocoder';



// WEBPACK FOOTER //
// ./src/common/constants/const-api.js